import { Spinner } from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "~/App";
import { useIdTokenQuery } from "./index.generated";
import { GraphqlClientContext } from "~/main";

export const AdminRedirect = () => {
  const [searchParams] = useSearchParams();
  const { refetchAdminAuth } = useContext(AuthContext);
  const { refreshGraphqlClient } = useContext(GraphqlClientContext);
  const navigate = useNavigate();
  const code = searchParams.get("code");

  useEffect(() => {
    refreshGraphqlClient();
  }, []);

  if (!code) {
    return <>Invalid Request</>;
  }
  const [getJwtTokenRes] = useIdTokenQuery({
    variables: {
      code,
    },
  });

  useEffect(() => {
    if (getJwtTokenRes.data?.adminIdToken.jwtToken) {
      localStorage.setItem(
        "jwt_token",
        getJwtTokenRes.data.adminIdToken.jwtToken
      );
      refetchAdminAuth()
        .then(() => {
          navigate("/admin");
        })
        .catch((e) => {
          navigate("/admin/login");
        });
    }
  }, [getJwtTokenRes]);

  return <Spinner />;
};
